var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-726 -579)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 25",
    cx: 31,
    cy: 31,
    r: 31,
    transform: "translate(726 579)",
    style: {
      fill: "rgba(255,115,29,.1)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 2151",
    transform: "translate(737.81 590.81)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 766",
    d: "M0 0h38.381v38.381H0z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "\\uC0AC\\uAC01\\uD615 6404",
    width: 25.587,
    height: 25.587,
    rx: 1,
    transform: "translate(6.397 6.397)",
    style: {
      stroke: "#ff731d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 14",
    transform: "translate(6.397 12.794)",
    style: {
      stroke: "#ff731d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px",
      fill: "none"
    },
    d: "M0 0h25.587"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 15",
    transform: "translate(12.794 6.397)",
    style: {
      stroke: "#ff731d",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "2.5px",
      fill: "none"
    },
    d: "M0 0v6.397"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPage);
export default __webpack_public_path__ + "static/media/ic-page.f06750ab.svg";
export { ForwardRef as ReactComponent };